import { PatientHead, useToast } from '@concord/ui';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router';
import type { Me } from '../../lib/session';
import { PatientLayout } from '../patient/PatientLayout';
import { IntakeWizard } from './IntakeWizard';

const LEADS: Record<string, string> = {
  history:
    'One question at a time. Your answers collect on the right, and you can change any of them before you send the case.',
  records:
    'Add the reports the physicians will need. Pathology, imaging reports and your oncologist’s letters matter most.',
  times:
    'Offer the times you could do a 30-minute video call. The physicians pick one of them, so the more you offer, the sooner it happens.',
};

/** The patient's own intake, in the patient frame. */
export function PatientIntake({ me }: { me: Me }) {
  const navigate = useNavigate();
  const toast = useToast();
  const qc = useQueryClient();
  const { id = '', step = 'type' } = useParams();
  return (
    <IntakeWizard
      mode="patient"
      base={`/cases/${id}/intake`}
      onSent={async (reference) => {
        await qc.invalidateQueries({ queryKey: ['patient-home'] });
        toast(`Sent. Your case reference is ${reference}.`);
        navigate('/home');
      }}
      frame={(content) => (
        <PatientLayout me={me}>
          <PatientHead
            title="Start a new case"
            lead={
              LEADS[step] ??
              'One question at a time. Your answers collect on the right, and you can change any of them before you send the case.'
            }
          />
          {content}
        </PatientLayout>
      )}
    />
  );
}
